import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import HeaderLayout from 'layout/HeaderLayout';

const Terms = Loadable(lazy(()=> import('views/Terms/Terms')))

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const PublicRoutes = {
    path: '/',
    element: <HeaderLayout />,
    children: [
        {
            path: '/terms-and-condition',
            element:<Terms/>
        }
    ]
};

export default PublicRoutes;
